import React from 'react';
import {
  Search,
  Type,
  User,
  Briefcase,
  Mail,
  Phone,
  Globe,
  MapPin,
  ClipboardList,
  CheckCircle2,
  RefreshCw,
  Plus,
  DollarSign,
  LucideIcon,
} from 'lucide-react';
import { TextLayoutProps } from '../Text';
import { useFormContext } from 'ui-builder';
import { Input, cn } from 'shadcn-ui';
import { InputLayoutIcon } from '../Text';
import ShadcnBaseInputLayout from '../../layout/ShadcnBaseInputLayout';

const iconMap: Record<InputLayoutIcon, LucideIcon> = {
  [InputLayoutIcon.SEARCH]: Search,
  [InputLayoutIcon.TEXT]: Type,
  [InputLayoutIcon.PERSON]: User,
  [InputLayoutIcon.WORK]: Briefcase,
  [InputLayoutIcon.EMAIL]: Mail,
  [InputLayoutIcon.PHONE]: Phone,
  [InputLayoutIcon.WEB]: Globe,
  [InputLayoutIcon.ADDRESS]: MapPin,
  [InputLayoutIcon.ASSIGNMENT]: ClipboardList,
  [InputLayoutIcon.COMPLETE]: CheckCircle2,
  [InputLayoutIcon.UPDATE]: RefreshCw,
  [InputLayoutIcon.ADD]: Plus,
  [InputLayoutIcon.PRICE]: DollarSign,
};

function ShadcnTextLayout(props: TextLayoutProps) {
  const formContext = useFormContext();

  const maxLength = formContext.getConstraintValue
    ? formContext.getConstraintValue(props.name, 'maxLength')
    : undefined;

  const IconComponent = props.icon ? iconMap[props.icon] : null;
  const isSearchIcon = props.icon === InputLayoutIcon.SEARCH;

  const input = (
    <div className="relative">
      {IconComponent && (
        <IconComponent
          className={cn(
            'absolute top-1/2 -translate-y-1/2 pointer-events-none',
            isSearchIcon
              ? 'right-3 size-4.5 text-gray-500'
              : 'left-3 size-4 text-gray-400',
          )}
        />
      )}
      <Input
        disabled={props.isDisabled}
        name={props.name}
        autoComplete="one-time-code"
        placeholder={props.placeholder}
        type={props.inputType || 'text'}
        value={props.value || ''}
        onChange={props.onChangeCallback}
        onFocus={props.onFocusCallback}
        onBlur={props.onBlurCallback}
        data-lpignore="true"
        data-form-type="other"
        min={props.min}
        max={props.max}
        maxLength={maxLength || undefined}
        className={cn(
          IconComponent && !isSearchIcon && '!pl-9',
          IconComponent && isSearchIcon && '!pr-9',
        )}
      />
    </div>
  );

  return (
    <ShadcnBaseInputLayout
      label={props.label}
      afterLabelElement={props.afterLabelElement}
      name={props.name}
      errors={props.errors}
      hint={props.hint}
      showLabel={props.showLabel}
      className={props.className}
      hideLabel={props.hideLabel}
      showRequiredIcon={props.showRequiredIcon}
      hideValidationErrors={props.hideValidationErrors}
    >
      {input}
    </ShadcnBaseInputLayout>
  );
}

export default ShadcnTextLayout;
